var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_0_17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21.5C5 18.45 6.2116 15.5249 8.36827 13.3683C10.5249 11.2116 13.45 10 16.5 10C19.55 10 22.4751 11.2116 24.6317 13.3683C26.7884 15.5249 28 18.45 28 21.5L23.9722 21.5C23.9722 19.5183 23.1849 17.6177 21.7836 16.2164C20.3823 14.8151 18.4817 14.0278 16.5 14.0278C14.5183 14.0278 12.6177 14.8151 11.2164 16.2164C9.81506 17.6177 9.02781 19.5183 9.02781 21.5H5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 21.5C5 18.45 6.2116 15.5249 8.36827 13.3683C10.5249 11.2116 13.45 10 16.5 10C19.55 10 22.4751 11.2116 24.6317 13.3683C26.7884 15.5249 28 18.45 28 21.5L23.9722 21.5C23.9722 19.5183 23.1849 17.6177 21.7836 16.2164C20.3823 14.8151 18.4817 14.0278 16.5 14.0278C14.5183 14.0278 12.6177 14.8151 11.2164 16.2164C9.81506 17.6177 9.02781 19.5183 9.02781 21.5H5Z",
    fill: "#408C88",
    fillOpacity: 0.4,
    stroke: "white",
    strokeOpacity: 0.07,
    strokeWidth: 0.242105,
    mask: "url(#path-2-inside-1_0_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21.5C5 19.1184 5.73945 16.7955 7.11623 14.8521C8.49302 12.9087 10.4392 11.4407 12.6861 10.6509C14.9329 9.86099 17.3696 9.78821 19.6596 10.4426C21.9496 11.0969 23.9799 12.4461 25.4702 14.3038L22.328 16.8247C21.3597 15.6177 20.0406 14.7411 18.5528 14.316C17.065 13.8908 15.4819 13.9381 14.0221 14.4513C12.5623 14.9645 11.2979 15.9182 10.4034 17.1808C9.50887 18.4435 9.02845 19.9526 9.02845 21.5H5Z",
    fill: "#408C88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/Score.b85fe2d3641b138148c0f5b0d44ea3e5.svg";
export { ForwardRef as ReactComponent };